module.exports = __webpack_public_path__ + "static/media/mountain-2.bd990718.jpg";